module.exports = __webpack_public_path__ + "img/slide-2__sm.95e29751.jpg";